import React__default from 'react';
import '../../../styles/fonts.css.js';

const typographyTags = {
    /*  h1: {
      weight: 'light',
      italic: false,
      size: 96,
      letterSpacing: -1.5,
      allCaps: false,
    },
    h2: {
      weight: 'light',
      italic: false,
      size: 60,
      letterSpacing: -0.5,
      allCaps: false,
    },
    h3: {
      weight: 'normal',
      italic: false,
      size: 48,
      letterSpacing: 0,
      allCaps: false,
    },
    h4: {
      weight: 'normal',
      italic: false,
      size: 34,
      letterSpacing: 0.25,
      allCaps: false,
    },
    h5: {
      weight: 'normal',
      italic: false,
      size: 24,
      letterSpacing: 0,
      allCaps: false,
    },
    h6: {
      weight: 'bold',
      italic: false,
      size: 20,
      letterSpacing: 0.15,
      allCaps: false,
    },
    subtitle1: {
      weight: 'normal',
      italic: false,
      size: 16,
      letterSpacing: 0.15,
      allCaps: false,
    },
    subtitle2: {
      weight: 'normal',
      italic: false,
      size: 14,
      letterSpacing: 0.1,
      allCaps: false,
    },
    body1: {
      weight: 'normal',
      italic: false,
      size: 16,
      letterSpacing: 0.5,
      allCaps: false,
    },
    body2: {
      weight: 'normal',
      italic: false,
      size: 14,
      letterSpacing: 0.25,
      allCaps: false,
    },
    button: {
      weight: 'bold',
      italic: false,
      size: 14,
      letterSpacing: 1.25,
      allCaps: true,
    },
    caption: {
      weight: 'normal',
      italic: false,
      size: 12,
      letterSpacing: 0.4,
      allCaps: false,
    },
    overline: {
      weight: 'normal',
      italic: false,
      size: 10,
      letterSpacing: 1.5,
      allCaps: false,
    }, */
    d1: {
        size: '4rem',
        weight: 'normal',
        letterSpacing: -0.1,
        italic: false,
        allCaps: false,
    },
    d2: {
        size: '3rem',
        weight: 'normal',
        letterSpacing: -0.1,
        italic: false,
        allCaps: false,
    },
    h1: {
        size: '2rem',
        weight: 'normal',
        letterSpacing: 0,
        italic: false,
        allCaps: false,
    },
    h2: {
        size: '1.8rem',
        weight: 'normal',
        letterSpacing: 0,
        italic: false,
        allCaps: false,
    },
    h3: {
        size: '1.6rem',
        weight: 'normal',
        letterSpacing: 0,
        italic: false,
        allCaps: false,
    },
    h4: {
        size: '1.4rem',
        weight: 'bold',
        letterSpacing: 0,
        italic: false,
        allCaps: false,
    },
    textlarge_strong: {
        size: '1.2rem',
        weight: 'bold',
        letterSpacing: 0,
        italic: false,
        allCaps: false,
    },
    textlarge: {
        size: '1.2rem',
        weight: 'normal',
        letterSpacing: 0,
        italic: false,
        allCaps: false,
    },
    textdefault_strong: {
        size: '1rem',
        weight: 'bold',
        letterSpacing: 0,
        italic: false,
        allCaps: false,
    },
    textdefault: {
        size: '1rem',
        weight: 'normal',
        letterSpacing: 0,
        italic: false,
        allCaps: false,
    },
    textsmall_strong: {
        size: '0.8rem',
        weight: 'bold',
        letterSpacing: 0,
        italic: false,
        allCaps: false,
    },
    textsmall: {
        size: '0.8rem',
        weight: 'normal',
        letterSpacing: 0,
        italic: false,
        allCaps: false,
    },
    textextrasmall_strong: {
        size: '0.7rem',
        weight: 'bold',
        letterSpacing: 0,
        italic: false,
        allCaps: false,
    },
    textextrasmall: {
        size: '0.7rem',
        weight: 'normal',
        letterSpacing: 0,
        italic: false,
        allCaps: false,
    },
    caption_strong: {
        size: '0.6rem',
        weight: 'bold',
        letterSpacing: 0.2,
        italic: false,
        allCaps: false,
    },
    caption: {
        size: '0.6rem',
        weight: 'normal',
        letterSpacing: 0.2,
        italic: false,
        allCaps: false,
    },
};
const Typography = ({ tag, children, color }) => {
    const params = typographyTags[tag];
    return (React__default.createElement("div", { style: {
            fontFamily: 'Siemens',
            fontWeight: params.weight,
            fontStyle: params.italic ? 'italic' : 'normal',
            fontSize: params.size,
            letterSpacing: params.letterSpacing,
            textTransform: params.allCaps ? 'uppercase' : 'inherit',
            color: color || params.color || 'inherit',
        } }, children));
};

export { Typography as default, typographyTags };
//# sourceMappingURL=Typography.js.map
